import { useState, useEffect } from 'react';
import {
  isPushSupported,
  subscribeToPush,
  unsubscribeFromPush,
  isSubscribedToPush,
  registerServiceWorker,
} from '../services/notifications';

export function NotificationToggle() {
  const [supported, setSupported] = useState(false);
  const [subscribed, setSubscribed] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const check = async () => {
      if (!isPushSupported()) return;
      setSupported(true);
      await registerServiceWorker();
      setSubscribed(await isSubscribedToPush());
    };
    check();
  }, []);

  if (!supported) return null;

  const toggle = async () => {
    setLoading(true);
    try {
      if (subscribed) {
        await unsubscribeFromPush();
        setSubscribed(false);
      } else {
        const ok = await subscribeToPush();
        setSubscribed(ok);
      }
    } finally {
      setLoading(false);
    }
  };

  // Hannah's only, and labelled so. services/notifications.ts subscribes this browser at Hannah's
  // cortex with Hannah's VAPID key. A browser holds one push subscription per service worker and
  // key, and Amanda's cortex key is not shown to match, so a per-mind subscription is not offered.
  return (
    <button
      type="button"
      className={`header-menu-item notification-toggle ${subscribed ? 'active' : ''}`}
      onClick={toggle}
      disabled={loading}
      aria-pressed={subscribed}
      title="Push notifications from Hannah, on this browser"
    >
      Hannah notifications: {subscribed ? 'on' : 'off'}
    </button>
  );
}
